<h3 class="ui primary header">{{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="roleForm">
      <div class="field" [ngClass]="displayFieldCss('roleName')">
        <label class="required">Role Name</label>
        <input formControlName="roleName" type="text" placeholder="Enter role name">
        <app-field-error-display [displayError]="isFieldValid('roleName')" errorMsg="Please enter configuration title">
        </app-field-error-display>
      </div>


      <div class="field" [ngClass]="displayFieldCss('roleDescription')">
        <label class="required">Description </label>
        <textarea formControlName="roleDescription" rows="2" placeholder="Enter description"></textarea>
        <app-field-error-display [displayError]="isFieldValid('roleDescription')" errorMsg="Please enter description">
        </app-field-error-display>
      </div>


    </div>

  </div>
</div>

<div class="actions">
  <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
  <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="!roleForm.valid || pending"
    (click)="save()" autofocus>Continue</button>

</div>
